<template>
    <div>
        <v-btn v-if="!editing" icon @click="edit">
            <span v-if="displayOrder">{{ displayOrder }}</span>
            <span v-else>{{ startList.order }}</span>
        </v-btn>
        <div v-else style="width: 75px" class="mt-4 mb-0 pb-0">
            <v-text-field
                ref="input"
                v-model.number="newOrder"
                outlined
                dense
                type="number"
                @blur="save"
                @keydown.enter="save"
            />
        </div>
    </div>
</template>

<script>
import StartList from '@/Models/StartList.js';

export default {
    name: 'StartListOrderEdit',

    props: {
        startList: {
            type: StartList,
            required: true,
        },

        displayOrder: {
            type: Number,
            required: false,
            default: null,
        },
    },

    data: () => ({
        editing: false,
        newOrder: null,
    }),

    methods: {
        edit() {
            this.newOrder = this.startList.order;
            this.editing = true;
            this.$nextTick(() => {
                this.$refs.input.focus();
            });
        },

        save() {
            if (this.newOrder === this.startList.order) {
                this.editing = false;
                return;
            }

            StartList.api()
                .put(`/api/start-lists/${this.startList.id}`, {
                    ...this.startList.$toJson(),
                    order: this.newOrder,
                })
                .then(() => {
                    this.editing = false;
                });
        },
    },
};
</script>
